module.exports = __webpack_public_path__ + "static/media/mastercard.7c18e17b.png";